import { createFileRoute } from '@tanstack/react-router'
import { getNewsItem, orNotFound } from '~/lib/content/content'
import { cacheHeaders } from '~/lib/site/cache'
import { searchType } from '~/lib/news/types'
import { articleHead } from '~/lib/site/seo'
import { ArticleLayout } from '~/components/sections/ArticleLayout'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'

export const Route = createFileRoute('/dxe-in-the-news/$slug')({
  loader: ({ params }) => orNotFound(getNewsItem({ data: params.slug })),
  headers: () => cacheHeaders.content,
  head: ({ loaderData: item }) =>
    item
      ? articleHead({
          type: 'NewsArticle',
          path: `/dxe-in-the-news/${item.slug}`,
          ...item,
          image: item.image?.src,
          fallbackDescription: `${item.category}${item.outlet ? ` from ${item.outlet}` : ''}: ${item.title}`,
        })
      : {},
  component: NewsItem,
})

function NewsItem() {
  const item = Route.useLoaderData()
  return (
    <>
      <ArticleLayout
        kicker={item.category}
        author={item.author}
        date={item.date}
        title={item.title}
        quote={item.quote}
        html={item.html}
        audio={item.audio}
        search={{
          type: searchType(item.category),
          label: item.category,
          outlet: item.outlet,
        }}
      >
        {item.url && (
          <p className="mt-5" data-pagefind-ignore>
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              className="text-lg font-bold text-accent hover:underline"
            >
              Read the full article{item.outlet ? ` at ${item.outlet}` : ''}
            </a>
          </p>
        )}
      </ArticleLayout>
      <DonateSignupBand />
    </>
  )
}
